import http from '@/helpers/Http'
export default {
    namespaced: true,
    state: {

    },
    getters: {

    },
    mutations: {

    },
    actions: {
        async updateEmail({ commit }, payload) {
            let response = await http.patch('account/email', payload)

            commit('auth/setUser', response.data, { root: true })

            return response
        },
        async updateProfile({ commit }, payload) {
            let response = await http.patch('account/profile', payload)

            commit('auth/setUser', response.data, { root: true })

            return response
        },
        async updatePassword({ commit }, payload) {
            return await http.patch('account/password', payload)
        },
        async delete({ commit }, payload) {
            await http.delete('account/delete', { data: payload })

            commit('auth/logout', null, { root: true })
        }
    }
}